module.exports = __webpack_public_path__ + "media/Revenge of the Living Dead Girls and Boys.22472a07.mp3";